import classNames from "classnames";
import { isString } from "lodash";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import Popover from "../Popover";

const Label = ({
  label,
  subLabel,
  optional,
  icon,
  labelSuffix,
  required,
  id,
  right,
}) => {
  const { t } = useTranslation(NAME_SPACES.ERRORS);
  const { t: components } = useTranslation(NAME_SPACES.COMPONENTS);
  const LABEL = components("LABEL", { returnObjects: true });
  const VALIDATIONS = t("VALIDATIONS", { returnObjects: true });

  return (
    <div className={classNames({ label__area: label, "hide--label": !label })}>
      <div className="label__area--left">
        {icon && (
          <span className={classNames("label__icon", { "hide--icon": !icon })}>
            {icon}
          </span>
        )}
        <label htmlFor={id || label}>
          <span dangerouslySetInnerHTML={{ __html: label }}></span>
          {subLabel && <span className="label__sub">{subLabel}</span>}
        </label>
        {labelSuffix && (
          <span className="label__icon label__suffix">{labelSuffix}</span>
        )}
        {!required && optional && (
          <span className="label__optional">
            {isString(optional) ? optional : LABEL.OPTIONAL}
          </span>
        )}
        {required && (
          <div className="popover-wrapper">
            <Popover text={VALIDATIONS.REQUIRED} />
            <span className="label__required">Obligatoire</span>
          </div>
        )}
      </div>
      {right && <div className="label__area--right">{right}</div>}
    </div>
  );
};

Label.propTypes = {
  label: PropTypes.any,
  className: PropTypes.string,
  icon: PropTypes.node,
  labelSuffix: PropTypes.node,
};

Label.defaultProps = {
  setType: () => {},
};

export default Label;
